import { createSlice } from "@reduxjs/toolkit";
import { pagination } from "../../../type/pagination";
import { deletedFarm } from "../../../type/admins/deleted-farms";

export const deletedFarmsData = createSlice({
  name: "all deleted farms",
  initialState: {
    value: {
      status: false,
      pagination: [] as {
        pagination_data: pagination;
        data: deletedFarm[];
      }[],
      data: [] as deletedFarm[],
    },
  },
  reducers: {
    updateDeletedFarms: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload?.data;
    },
    addDeletedFarmToList: (state, action) => {
      state.value.data = [...state.value.data, action?.payload];
      //include in pagination data
      const pagination_data = [...state.value.pagination];
      const lastIndex = pagination_data?.length - 1;
      const addedItem = pagination_data.map((item, index) => {
        if (lastIndex === index) {
          return {
            pagination_data: item?.pagination_data,
            data: [...item.data, action?.payload],
          };
        } else {
          return item;
        }
      });
      state.value.pagination = addedItem;
    },
    addToPaginationHistory: (state, action) => {
      const found = state.value?.pagination?.find(
        (item) =>
          item?.pagination_data?.current_page ===
          action?.payload?.pagination_data?.current_page
      );
      if (!found) {
        state.value.pagination = [
          ...state.value.pagination,
          {
            pagination_data: action?.payload?.pagination_data,
            data: action?.payload?.data,
          },
        ];
      }
    },
    removeDeletedFarmInList: (state, action) => {
      const { _id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { _id: string }) => v._id === _id
      );
      if (currentIndex >= 0) {
        currentArray.splice(currentIndex, 1);
        state.value.data = currentArray;
      }
      //remove from paginated data
      const pagination_data = [...state.value.pagination];
      const removed = pagination_data.map((item, index) => {
        const sencondFilter = item.data.filter((data, i) => {
          return !(String(data._id) === String(_id));
        });
        return {
          pagination_data: { ...item.pagination_data },
          data: sencondFilter,
        };
      });
      state.value.pagination = removed;
    },
    replaceDeletedFarmInList: (state, action) => {
      const { _id } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { _id: string }) => v._id === _id
      );
      if (currentIndex >= 0) {
        currentArray.splice(currentIndex, 1, action?.payload);
        state.value.data = currentArray;
      }
      //REPLACE pagination data
      const pagination_data = [...state.value.pagination];
      const replacedItem = pagination_data.map((item, index) => {
        const sencondFilter = item.data.map((data, i) => {
          if (String(data._id) === String(_id)) {
            return { ...action.payload };
          } else {
            return data;
          }
        });
        return {
          pagination_data: { ...item.pagination_data },
          data: sencondFilter,
        };
      });
      state.value.pagination = replacedItem;
    },
    clearDeltedFarmList: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  updateDeletedFarms,
  addDeletedFarmToList,
  addToPaginationHistory,
  removeDeletedFarmInList,
  replaceDeletedFarmInList,
  clearDeltedFarmList,
} = deletedFarmsData.actions;

export default deletedFarmsData.reducer;
